import React from 'react';

const Component = props => {
	return (
		<>
			<div className='pt-[5px]'>
				<h2 className='text-[36px] text-[#282e3f] mb-[25px]'>Droit de la responsabilité</h2>
			</div>
			<div className='mt-[30px]'>
				<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
					Le cabinet GAVA-<i>Lex</i> vous conseillera et vous défendra dans tous les dossiers où votre{' '}
					<strong>responsabilité</strong> est recherchée (responsabilité personnelle, des enfants, des
					animaux, etc…).{' '}
				</p>
				<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
					Le cabinet vous conseillera et vous défendra également si vous êtes victime et que vous recherchez
					la responsabilité d'une tierce personne.{' '}
				</p>
				<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
					Quelqu'un prétend que vous avez commis une <strong>faute</strong> qui lui a causé un{' '}
					<strong>dommage</strong> ? Le cabinet tentera de contester votre responsabilité en fonction des
					éléments en sa possession ou qu'il vous proposera de rassembler. De même, si vous avez subi un
					préjudice occasionné par une tierce personne, le cabinet vous accompagnera en vue de rechercher la
					responsabilité de cette dernière et et d'obtenir <strong>indemnisation</strong> à charge de l'auteur
					des faits ou de son assureur.{' '}
				</p>
				<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
					Vos <strong>enfants</strong> ont commis une « bêtise » ? Votre responsabilité peut être recherchée
					en votre qualité de <strong>parent</strong> civilement responsable. A nouveau, le cabinet examinera
					la situation et tentera au mieux de contester votre responsabilité et celle de vos enfants.{' '}
				</p>
				<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
					Votre chien a mordu une tierce personne ? Votre responsabilité peut être recherchée en qualité de
					gardien de l'<strong>animal</strong>. Vous avez été mordu par le <strong>chien</strong> d'une tierce
					personne ? Vous pouvez rechercher la responsabilité et obtenir indemnisation auprès du gardien du
					chien. Dans les deux cas, le cabinet vous conseillera et défendra au mieux.{' '}
				</p>
				<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
					Votre responsabilité <strong>professionnelle</strong> (médecin, architecte, comptable, entrepreneur,
					etc…) est recherchée, le cabinet vous conseillera au mieux pour contester celle-ci. A l'inverse, si
					vous avez subi un <strong>dommage</strong> en raison d'une faute quelconque, le cabinet vous
					aiguillera au mieux en vue de rechercher la responsabilité professionnelle de l'auteur du dommage.{' '}
				</p>
				<div className='organigation-text w-[64%] col:float-none  col:w-full mt-[30px]'>
					<h2 className='text-[24px] text-[#282e3f] mb-[8px] block'>Aperçu des Cas Pratiques : </h2>
					<span className='block pt-[15px] text-[15px] text-[#333]'>
						<i className='fa fa-check-square-o text-[#c0b596] pr-[15px]' aria-hidden='true'></i>
						Responsabilité personnelle
					</span>
					<span className='block pt-[15px] text-[15px] text-[#333]'>
						<i className='fa fa-check-square-o text-[#c0b596] pr-[15px]' aria-hidden='true'></i>
						Responsabilité des enfants
					</span>
					<span className='block pt-[15px] text-[15px] text-[#333]'>
						<i className='fa fa-check-square-o text-[#c0b596] pr-[15px]' aria-hidden='true'></i>
						Responsabilité des animaux (chien, etc…)
					</span>
					<span className='block pt-[15px] text-[15px] text-[#333]'>
						<i className='fa fa-check-square-o text-[#c0b596] pr-[15px]' aria-hidden='true'></i>
						Responsabilité professionnelle
					</span>
				</div>
			</div>
		</>
	);
};

export default Component;
